<template>
	<div style="margin: 20px;">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item ><span style="cursor: pointer;" @click="gotoSetting">系统设置</span></el-breadcrumb-item>
			<el-breadcrumb-item>系统自定义置</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row>
			<el-col :span="24" style="margin: 0px 0 20px 0;">
				<div style="font-size: 18px;color: #333333;display: flex;">
					<div class="iconDiv">
						.
					</div>
					违规处理与信用积分设置
				</div>
			</el-col>
		</el-row>
		<div class="pasadyangSeting-div" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<div style="margin: 0px 20px 20px 12px;">
        <el-tag type="warning" style="width: 100%;margin-top: 20px;">
          <img src="../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
          设置经销商层级别名后，给经销商显示的将会是经销商层级别名，如果未设置则显示默认值。
        </el-tag>
      </div>
			<el-row style="font-weight: bold;font-size: 16px;background-color: #f2f6fe;margin: 12px 12px 0 12px;color: #4a4b4c">
				<el-col :span="12">
					<div style="margin: 12px 24px;">
						经销商层级
					</div>
				</el-col>
				<el-col :span="8">
					<div style="margin: 12px;">
						层级别名
					</div>
				</el-col>
				<el-col :span="4" style="text-align: center;">
					<div style="margin: 12px;">
						操作
					</div>
				</el-col>
			</el-row>

			<el-row style="border-bottom: 1px solid #EBEEF5;margin: 0 12px;" v-for="(item,index) in nameData">
				<el-col :span="12" style="line-height: 33px;">
					<div style="margin: 12px 24px;">
						{{item.moudle}}
					</div>
				</el-col>
				<el-col :span="8" style="line-height: 33px;">
					<div style="margin: 12px;">
						<el-input v-model="item.inputData" placeholder="请输入内容" style="width: 360px;" size="mini" :disabled="item.setShow"></el-input>
					</div>
				</el-col>
				<el-col :span="4" style="text-align: center;line-height: 53px;" v-if="item.setShow">
					<el-button type="text" @click="setChange(index,item.setShow)">编辑</el-button>
				</el-col>
				<el-col :span="2" style="text-align: center;line-height: 53px;" v-if="!item.setShow">
					<el-button type="text" @click="updateDealerLevelAlias(index,item.setShow,item)" clearable>确认</el-button>
				</el-col>
				<el-col :span="2" style="text-align: center;line-height: 53px;" v-if="!item.setShow">
					<el-button type="text" @click="setChange(index,item.setShow)">取消</el-button>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			nameData: [],
			loading: false,
		}
	},
	mounted() {
		this.initDealerLevelAlias();
	},
	methods: {
		// 初始化经销商层级别名
		initDealerLevelAlias() {
			this.loading = true
			fetch({
        url: "/hcm/cus/initDealerLevelAlias",
        method: "post",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					this.getDealerLevelAlias()
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		// 获取经销商层级别名列表
		getDealerLevelAlias() {
			fetch({
        url: "/hcm/cus/getDealerLevelAlias",
        method: "post",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					this.nameData = []
					for (let a in res.data) {
						this.nameData.push({
							setShow: true,
							inputData: res.data[a].alias,
							moudle: res.data[a].moudle,
							id: res.data[a].id,
						})
					}
					this.loading = false
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		// 修改经销商层级别名
		updateDealerLevelAlias (index,setShow,item) {
			let id
			let alias
			let num = Number(index)+1
			alias = item.inputData
			id = item.id
			let params={
        id: id,
        alias: alias,
      }
      fetch({
        url: "/hcm/cus/updateDealerLevelAlias",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					if (setShow) {
						this.nameData[index].setShow = false
					} else {
						this.nameData[index].setShow = true
					}
          this.initDealerLevelAlias();
        } else {
					this.nameData[index].inputData = ''
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		// 修改设置
		setChange(index,setShow) {
			if (setShow) {
				this.nameData[index].setShow = false
			} else {
				this.nameData[index].setShow = true
			}
		},
		// 跳转到上一级
		gotoSetting() {
			this.$router.push('/systemSetupList/systemSetup');
		}
	}
}
</script>

<style lang='scss'>
	.pasadyangSeting-div {
		background-color: white;
		border-radius: 15px;
		padding-bottom: 20px;
	}
	.iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }
</style>
